import React, { useEffect, useState } from 'react'

import {
    Menu,
    MenuHandler,
    MenuList
} from "@material-tailwind/react";

import ToggleIcon from '../../admin/toggleCard/ToggleIcon';
import { useNavigate } from 'react-router-dom';

function MenuInfoDoctor() {
    const user = JSON.parse(localStorage.getItem('user'))
    const [toggle, setToggle] = useState(false)
    const navigate = useNavigate()

    const [widtht, setWidth] = useState(0);

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newWidth = window.innerWidth;
            setWidth(newWidth);
            // console.log("updating Width");
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    useEffect(() => {
        if (widtht < 767) {
            setToggle(false)
        }
    }, [widtht])

    return (
        <Menu open={toggle}>
            <MenuHandler onClick={() => { setToggle(!toggle) }}>
                <button className="flex h-full items-center mr-11 lg:mr-4 md:mr-1 sm:mr-0 px-3 border-l border-[#FF9768] hover:drop-shadow-sm">
                    <img className={user?.profile_image ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full" : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"} src={user?.profile_image ? user?.profile_image : require('../../../asset/icon/iconuser.svg').default} alt="iconuser" />
                    <p className="text-[#FF9768] text-lg font-medium px-3 lg:text-sm">{user?.fname + ' ' + user?.lname}</p>
                    <ToggleIcon toggleCards onToggle={() => { setToggle(!toggle) }} toggleStatus={toggle} />
                </button>
            </MenuHandler>
            <MenuList dismiss className="flex flex-col items-center mt-7 w-80 rounded-3xl">
                <img className={user?.profile_image ? "w-[48px] h-[48px] rounded-full my-2" : "w-[48px] h-[48px] my-2"} src={user?.profile_image ? user?.profile_image : require('../../../asset/icon/iconuser.svg').default} alt="" />
                <p className="text-[#FF9768] text-lg">{user?.fname + ' ' + user?.lname}</p>
       
                <button onClick={() => {
                    localStorage.clear()
                    navigate('/login')
                }} className="button-theme-pg flex justify-center items-center bg-white w-11/12 mt-8 rounded-full h-12 ring-1 ring-[#FF9768]">
                    <img src={require("../../../asset/icon/logout.svg").default} alt="" className="mr-2" />
                    <p className="text-[#FF9768] text-base">ออกจากระบบ</p>
                </button>
            </MenuList>
        </Menu>
    )
}

export default MenuInfoDoctor